module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/60ad32c07eeb04fa6c3ee68586572329.png";